import { render, staticRenderFns } from "./LaneClosureBlockMobile.vue?vue&type=template&id=5dd2300d&"
import script from "./LaneClosureBlockMobile.vue?vue&type=script&lang=js&"
export * from "./LaneClosureBlockMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports